<template>
  <div class="col col-lg-3">
    <div class="input-group">
      <label for="cpfField">
        CPF 
        <!-- <span v-if="isRequired" class="required-markup">*</span> -->
        <span class="recent-updated-label" v-if="recentUpdatedField">
          <tooltip-informacao-alterada />
        </span>
        <input
          class="form-control"
          :class="{
            'is-invalid': $v.model.content.$error,
            'recent-updated': recentUpdatedField,
          }"
          id="cpfField"
          :disabled="disabled"
          v-mask="'999.999.999-99'"
          v-model.trim="$v.model.content.$model"
        />
        <div class="form-text">Preencha com o CPF do contato.</div>
      </label>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import { isCpf } from "@/filters/assertions";
import { validateCPF } from "@/utils/functionUtils";
import { requiredIf } from "vuelidate/lib/validators";
import TooltipInformacaoAlterada from "@/components/forms/TooltipInformacaoAlterada.vue";
export default {
  props: {
    disabled: Boolean,
    modelProp: Object,
    isRequired: Boolean,
    recentUpdatedField: Boolean,
  },
  data() {
    return {
      model: {
        name: "cpf",
        content: "",
      },
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    isInvalid() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.mxToggleErrorMessageAlert("Campo CPF inválido");
        return true;
      }
      return false;
    },
  },
  watch: {
    "model.content": {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          if (oldVal.replace(/[^\d]/g, "") != newVal.replace(/[^\d]/g, "")) {
            this.modelProp[this.model.name] = this.model.content;
          }
        } else {
          this.modelProp[this.model.name] = this.model.content;
        }
      },
    },
    modelProp: {
      deep: true,
      handler() {
        this.model.content = this.modelProp[this.model.name];
      },
    },
  },
  validations: {
    model: {
      content: {
        // required: requiredIf(function () {
        //   return this.isRequired;
        // }),
        isCpf,
        validateCPF,
      },
    },
  },
  components: {
    TooltipInformacaoAlterada,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/style.scss";
label {
  width: 100% !important;
}
</style>
